import { Dropdown, Tooltip } from 'antd';
import { Check, Languages } from 'lucide-react';

import { LANGUAGES, useI18n } from '../../i18n';

export const LanguageSwitcher = ({ compact = false }) => {
  const { t, language, meta, setLanguage } = useI18n();

  const items = [
    {
      type: 'group',
      label: t('header.language'),
      children: LANGUAGES.map(lang => ({
        key: lang.code,
        label: (
          <span style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 170 }}>
            <span className='wm-kbd' style={{ minWidth: 30, justifyContent: 'center' }}>
              {lang.short}
            </span>
            <span style={{ flex: 1 }}>{lang.label}</span>
            {lang.code === language && <Check size={14} strokeWidth={2.25} />}
          </span>
        ),
      })),
    },
  ];

  return (
    <Dropdown
      trigger={['click']}
      placement='bottomRight'
      menu={{ items, selectable: true, selectedKeys: [language], onClick: ({ key }) => setLanguage(key) }}
    >
      <Tooltip title={t('header.language')} placement='bottom'>
        <button
          type='button'
          className='wm-icon-btn'
          aria-label={t('header.language')}
          style={compact ? undefined : { width: 'auto', padding: '0 8px', gap: 6, gridAutoFlow: 'column' }}
        >
          <Languages size={18} strokeWidth={1.75} />
          {!compact && <span style={{ fontSize: 12, fontWeight: 600 }}>{meta.short}</span>}
        </button>
      </Tooltip>
    </Dropdown>
  );
};
